import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/content";
import { Reveal } from "../motion";

export const CtaBand = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden" data-testid="section-cta-finale">
      <div className="absolute inset-0">
        <img src={IMAGES.neonWall} alt="Univers Demoiselle Atypique — néon de la marque dans un décor aubergine, immobilier, liberté, audace, plaisir" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/85" />
      </div>
      <div className="relative mx-auto max-w-[1500px] px-6 py-28 text-center sm:px-10 lg:px-16 lg:py-40">
        <Reveal>
          <h2 className="mx-auto max-w-4xl font-serif text-4xl leading-[1.1] text-cream sm:text-5xl lg:text-6xl">
            Votre projet mérite d'être pensé autrement.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-xl text-white/60">
            Présentez-nous votre idée : nous vous dirons comment la transformer en un lieu désirable et rentable.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <button onClick={() => navigate("/rendez-vous")} data-testid="ctaband-button" className="btn-primary mt-10">
            Parler de mon projet <ArrowRight className="h-4 w-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
